import { gql } from '@apollo/client';
import PRODUCT_FRAGMENT from 'graph/fragments/product';
import PRODUCT_CURRICULUM_FRAGMENT from 'graph/fragments/product-curriculum';

const GET_ADMIN_CLASSROOM_DETAILS = gql`
  query getAdminClassroomDetails($where: ClassroomWhereInput!) {
    classroom(where: $where) {
      id
      name
      color
      studentCount
      stats {
        userCount
        studentCount
      }
      licenseUsage {
        assignedCount
        product {
          ...BaseProduct
        }
        productCurriculum {
          ...BaseProductCurriculum
        }
      }
      students {
        id
        firstName
        lastName
        username
        email
        password
        gradeLevel
        licenseUsage {
          assignedCount
          product {
            ...BaseProduct
          }
          productCurriculum {
            ...BaseProductCurriculum
          }
        }
      }
      organizationId
      organization {
        id
        name
        type
        parentOrganization {
          name
          type
        }
      }
    }
  }
  ${PRODUCT_FRAGMENT}
  ${PRODUCT_CURRICULUM_FRAGMENT}
`;

export default GET_ADMIN_CLASSROOM_DETAILS;
